import SideBySideWithIconsTextAndAssetComponent from "./side-by-side-with-icons-text-and-asset-component";
import SideBySideWithIconsTextAndAssetConfig from "./side-by-side-with-icons-text-and-asset-config";
import SideBySideWithIconsTextAndAssetAdvancedConfig from "./side-by-side-with-icons-text-and-asset-advanced-config";
export default {
    SideBySideWithIconsTextAndAssetComponent,
    SideBySideWithIconsTextAndAssetConfig,
    SideBySideWithIconsTextAndAssetAdvancedConfig
};
